// @ts-nocheck
import { authMiddleware } from "Middlewares";
import { rootReducer } from "Reducers";
import { configureStore } from "@reduxjs/toolkit";
import persistStore from "redux-persist/es/persistStore";
import { defaultLeftMenuState } from "Reducers/leftMenuReducer";

const persistedState = localStorage.getItem("left-menu")
  ? {
    leftMenu: {
      ...defaultLeftMenuState,
      ...JSON.parse(localStorage.getItem("left-menu"))
    }
  }
  : {};

const store = configureStore({
  reducer: rootReducer,
  preloadedState: persistedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false

    }).concat(authMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
});

store.subscribe(() => {
  localStorage.setItem("left-menu", JSON.stringify(store.getState().leftMenu));
});

export const persistor = persistStore(store);

export default store;
